<template>
  <div class="container-page">
    <div>
      <p class="title-inner">
        {{ pageTitle }}
      </p>

      <div class="mb-16 d-flex flex-row">
        <ButtonComponent class="mr-2" mod="gradient-bg" @click="editCard(0)" v-if="canEdit">Создать</ButtonComponent>

        <ButtonComponent mod="gradient-bg" @click="exportExcel()" v-if="showExport">Экспорт</ButtonComponent>
        <slot name="buttons"></slot>
      </div>
      <div class="mb-4">
        <DefaultFilter :filterValue="filter" @loadFilter="onLoadFilter" />
      </div>

      <div v-if="page.items">
        <div class="table-container mb-16 js-table-arrow" v-if="page.items">
          <table class="stockTable">
            <thead>
              <tr>
                <th>Наименование</th>
                <th v-if="isEventTypes">Категория</th>
                <th>Статус</th>
                <th v-if="isEventTypes" class="sortable">Сортировка</th>
                <th v-if="canEdit"></th>
                <th v-if="canEdit"></th>
              </tr>
              <tr>
                <th class="filter">
                  <FilterInput
                    placeholder="Введите название..."
                    v-model="filter.name"
                    v-on:valueChangedDebounced="changeFilter"
                  />
                </th>
                <th v-if="isEventTypes" class="filter">
                  <FilterInput
                    type="select2"
                    :select2Options="categoryOptions"
                    :select2Settings="select2Settings"
                    v-model="filter.categoryId"
                    placeholder="Выберите категорию"
                    @update:modelValue="onCategoryChange"
                  />
                </th>
                <th class="filter">
                  <FilterActiveInput v-model="filter.active" @valueChangedDebounced="changeFilter" />
                </th>
                <th v-if="isEventTypes" class="filter">
                  <FilterInput
                    type="select2"
                    :select2Options="sortedOptions"
                    :select2Settings="select2Settings"
                    v-model="filter.sort"
                    placeholder="Сортировать по..."
                    @update:modelValue="onSortChange"
                  />
                </th>
                <th v-if="canEdit" class="filter"></th>
                <th v-if="canEdit" class="filter"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in page.items" :key="item.id">
                <td class="d-flex align-items-center">
                  <div
                    v-if="item.picture"
                    class="imagePreviewWrapper mr-8"
                    :style="{ 'background-image': `url(${item.picture})` }"
                  ></div>
                  {{ item.name }}
                </td>
                <td v-if="isEventTypes">
                  {{ getCategoryName(item.categoryId) }}
                </td>
                <td>
                  <ActiveComponent :value="item.isActive" />
                </td>
                <td v-if="isEventTypes">{{ item.sortValue ?? 0 }}</td>
                <td v-if="canEdit">
                  <IconComponent @click="editCard(item.id)" name="mode" />
                </td>
                <td v-if="canEdit">
                  <IconComponent @click="deleteCard(item.id)" name="delete" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="page.pagesTotal > 1">
          <Pagination
            :pageCount="page.pagesTotal"
            :currentPage="page.pageNumber"
            @change="onPageChange($event, false)"
            @more="onPageChange($event, true)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import FilterActiveInput from '@/common/components/FilterActiveInput.vue';
  import FilterInput from '@/common/components/FilterInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import ActiveComponent from '@/common/ui/ActiveComponent.vue';
  import IconComponent from '@/common/ui/IconComponent.vue';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import API from '../api/nsi';

  export default {
    name: 'NsiTable',
    components: {
      ButtonComponent,
      IconComponent,
      ActiveComponent,
      FilterInput,
      FilterActiveInput,
      DefaultFilter,
    },
    props: {
      pageTitle: String,
      apiRoute: String,
      apiRouteSecond: String,
      cardName: String,
      canEdit: {
        type: Boolean,
        default: true,
      },
      showExport: {
        type: Boolean,
        default: false,
      },
      additionalFilter: {
        type: Object,
        default: null,
      },
      isEventTypes: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        page: {},
        categories: [],

        filter: {
          name: '',
          active: null,
          categoryId: null,
          sort: '0',
        },

        select2Settings: {
          allowClear: true,
          multiple: false,
        },

        sortedOptions: [
          { id: '0', text: 'По возрастанию' },
          { id: '1', text: 'По убыванию' },
        ],
      };
    },
    computed: {
      categoryOptions() {
        return this.categories.map((category) => ({
          id: category.id,
          text: category.name,
        }));
      },
    },
    created() {
      loadFilter(this.$options.name, this.apiRoute).then((response) => {
        let filter = response;
        if (filter) {
          this.filter = filter;
        }
        this.loadPage(false);
      });

      if (this.isEventTypes) {
        this.loadCategories();
      }
    },
    methods: {
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      loadPage(addToExist) {
        var params = Object.assign({}, this.request);
        if (this.additionalFilter) {
          params = Object.assign(params, this.additionalFilter);
        }

        params.name = this.filter.name;
        params.isActive = this.filter.active;

        if (this.isEventTypes && this.filter.categoryId) {
          params.categoryId = this.filter.categoryId;
        }

        if (this.isEventTypes && this.filter.sort) {
          params.sortOrder = this.filter.sort;
        }

        API.search(this.apiRoute, params).then((response) => {
          if (!addToExist) {
            this.page = {};
            this.$nextTick(() => {
              this.page = response.data;
            });
          } else if (response.data) {
            //добавляем к существующему
            this.page.pageNumber = response.data.pageNumber;
            this.page.items = this.page.items.concat(response.data.items);
          }
        });
      },
      loadCategories() {
        API.search(this.apiRouteSecond, {}).then((response) => {
          this.categories = response.data.items;
        });
      },

      onCategoryChange(value) {
        this.filter.categoryId = value;
      },
      onSortChange(value) {
        this.filter.sort = value;
      },
      editCard(id) {
        this.$router.push({ name: this.cardName, params: { id: id, action: 'edit' } });
      },
      deleteCard(id) {
        Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
          if (res.isConfirmed) {
            API.delete(this.apiRoute, id)
              .then(() => {
                Constants.alert.fire('Удаление', 'Запись удалена', 'success');
                this.loadPage();
              })
              .catch((/*error*/) => {
                //Constants.alert.fire('Удаление',error.response && error.response.data ? error.response.data : "Запись не удалена", 'error');
                Constants.alert.fire(
                  'Удаление',
                  'Запись не удалена. Возможно, она используется в других объектах.',
                  'error',
                );
              });
          }
        });
      },
      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter, this.apiRoute);
        this.loadPage(false);
      },
      exportExcel() {
        API.exportExcel(this.apiRoute);
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },
      getCategoryName(categoryId) {
        if (!categoryId) return '—';
        const category = this.categories.find((cat) => cat.id === categoryId);
        return category ? category.name : '—';
      },
    },
    watch: {
      additionalFilter: {
        handler: function () {
          this.changeFilter();
        },
        deep: true,
      },
      'filter.categoryId': {
        handler: function (newVal, oldVal) {
          if (newVal !== oldVal) {
            this.changeFilter();
          }
        },
      },
      'filter.sort': {
        handler: function (newVal, oldVal) {
          if (newVal !== oldVal) {
            this.changeFilter();
          }
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  .icon {
    color: $green;
  }
  .table-container table {
    min-width: auto;
    width: 100%;
  }

  .imagePreviewWrapper {
    width: 25px;
    height: 25px;
    display: block;
    cursor: pointer;
    background-size: cover;
    background-position: center center;
  }
</style>
